<template>
  <div id="offcanvas-usage" uk-offcanvas="mode: reveal">
    <div class="uk-offcanvas-bar">
      <button class="uk-offcanvas-close" type="button" uk-close></button>
      <a
        class="uk-button uk-button-active uk-width uk-width-expand uk-light"
        href="https://github.com/ronitrex"
      >
        <span uk-icon="icon:github; ratio: 3"></span>
        <h4>github.com/ronitrex</h4>
      </a>
      <hr class="uk-divider-icon" />
      <ul
        uk-nav
        uk-accordion="collapsible: false"
        class="uk-width uk-width-expand"
      >
        <li v-for="item in items" v-bind:key="item.id">
          <a class="uk-accordion-title" v-html="item.repoName"></a>
          <div class="uk-accordion-content" v-html="item.repoDesc"></div>
        </li>
      </ul>
      <hr class="uk-divider-icon" />
      <h3>विद्या ददाति विनयं विनयाद्याति पात्रताम् ।</h3>
      <p>
        Education leads to sensibility, sensibility attains
        character/qualification;
      </p>
      <a
        class="uk-link-muted uk-link-reset"
        href="./assets/ronin.pdf"
        target="_blank"
        ><h3>पात्रत्वाद्धनमाप्नोति धनाद्धर्मं ततः सुखम् ॥</h3>
        <p>
          from that comes wealth and from wealth (one does) good deeds, from
          that (comes) joy.
        </p></a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      items: [
        {
          id: 1,
          repoName: "ARM-LEGv8 CPU",
          repoDesc:
            'Multi-cycle pipelined ARM-LEGv8 CPU with Forwarding and Hazard Detection. <a href="https://github.com/ronitrex/ARMLEG" target="_blank">View on Github</a>',
        },
        {
          id: 2,
          repoName: "Mental Health",
          repoDesc:
            'Supervised Machine Learning model trained on OSMIhelp.org mental health datasets. <a href="https://github.com/ronitrex/MentalHealth" target="_blank">View on Github</a>',
        },

        {
          id: 3,
          repoName: "Search Engine",
          repoDesc:
            'Advanced Search Engine featuring Boolean Search and Ranked Retrieval. <a href="https://github.com/ronitrex/SearchEngine" target="_blank">View on Github</a>',
        },
        {
          id: 4,
          repoName: "Travelling Salesman",
          repoDesc:
            'Multi-threaded optimal solution for Travelling Salesman Problem using Branch and Bound. <a href="https://github.com/ronitrex/TravellingSalesman" target="_blank">View on Github</a>',
        },
        {
          id: 5,
          repoName: "Personal Website",
          repoDesc:
            'Personal website deployed at ronitrex.github.io <a href="https://github.com/ronitrex/PersonalWebsite" target="_blank">View on Github</a>',
        },
        {
          id: 6,
          repoName: "KaliBook",
          repoDesc:
            'Some notes on running Kali Linux on MacBook Air 7,2. <a href="https://github.com/ronitrex/KaliBook" target="_blank">View on Github</a>',
        },
      ],
    };
  },
};
</script>

<style scoped>
h3,
h4,
p {
  font-family: "overpass", sans-serif;
  font-weight: 600;
  font-style: normal;
}
</style>
